<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col">Expense Item</div>
            <div class="col-auto">
                <span style="text-align-last: end;" class="badge success px-1">Approve Amount : {{calTotal()}}</span>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="row g-0">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th>Category</th>
                        <th style="display: none;">Class</th>
                        <th>ExpenseDate</th>
                        <th>Description</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Kilometers</th>
                        <th>Rate</th>
                        <th>Amount</th>
                        <th>ApprovedAmount</th>
                        <th>Attachment</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 120px;">
                            <div style="width: 120px;">{{TableData['Expense/Category']}}</div>
                        </td>
                        <td style="width: 120px;display: none;">
                            <div style="width: 120px;">{{TableData['ClassName']}}</div>
                        </td>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['ExpenseDate']}}</div>
                        </td>
                        <td style="width: 200px;">
                            <div style="width: 200px;">{{TableData['Description']}}</div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['FromLocation']}}</div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['ToLocation']}}</div>
                        </td>
                        <td style="width: 70px;text-align:end">
                            <div style="width: 70px;">{{TableData['Kilometers']}}</div>
                        </td>
                        <td style="width: 50px;text-align:end">
                            <div style="width: 50px;">{{TableData['Rate']}}</div>
                        </td>
                        <td style="width: 80px;text-align:end">
                            <div style="width: 80px;">{{TableData['ExpenseAmount']}}</div>
                        </td>
                        <td style="width: 80px;text-align:end">
                            <div style="width: 80px;">{{TableData['ApprovedAmount']}}</div>
                        </td>
                        <td style="text-align: -webkit-center;">
                            <div style="width: 10px;"><a
                                    *ngIf="TableData['Attachment'] != '' && TableData['Attachment'] != null"
                                    [href]="TableData['Attachment']" target="_blank" class="bi bi-paperclip"></a></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end notification-action">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="close()"><i
                    class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
            <button type="button"
            *ngIf="(this.common.PageRight.IsAdd || this.common.PageRight.IsEdit)"
                (click)="ESS_ExpenseRequestUpdateAtApproval(TableDatas[0]['ESS_ExpenseReportRequestId'])"
                class="btn btn-success mx-1" [disabled]="IsReimbursed"><i
                    class="bi bi-check2"></i>Reimburse</button>
        </div>
    </div>
</div>